var React = require('react');

function SpinnerWhiteInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF"},[React.createElement("path",{"d":"M15.009 3C21.619 3.007 27 8.387 27 14.998c0 6.62-5.384 12.004-12 12.004-6.618 0-12-5.385-12.002-12L0 15c0 8.273 6.73 15 14.998 15 8.274 0 15-6.73 15.002-15C30 6.734 23.276.006 15.008.002L15.01 3z","opacity":".35","key":0}),React.createElement("path",{"d":"M0 15l3 .002v-.004C3 8.383 8.384 3.002 15 3.002 15.005 3 15.007 3 15.01 3L15.009.002c-.004 0-.005 0-.008-.002C6.728 0-.002 6.73 0 15z","key":1})]));
}

SpinnerWhiteInline.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30"};

module.exports = SpinnerWhiteInline;

SpinnerWhiteInline.default = SpinnerWhiteInline;
